import { render, staticRenderFns } from "./y_upload_img.vue?vue&type=template&id=4a20ec1c&scoped=true"
import script from "./y_upload_img.vue?vue&type=script&lang=js"
export * from "./y_upload_img.vue?vue&type=script&lang=js"
import style1 from "./y_upload_img.vue?vue&type=style&index=1&id=4a20ec1c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a20ec1c",
  null
  
)

export default component.exports